<p-toast position="top-right"></p-toast>
<div class="p-g">
    <div class="p-g-12">
        <div class="card card-w-title">
            <h1>{{setLabel("bookingsManagementLabel")}}</h1>
            <p-table #dt [value]="Bookings" dataKey="id" [first]="first" class="p-table-tecfolk-fix"
                styleClass="p-table-customers" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
                [loading]="loading" [paginator]="true" currentPageReportTemplate="There are {{
                    Bookings?.length
                }} records" [filterDelay]="0" [globalFilterFields]="[
                    'name',
                    'status'
                ]">
                <ng-template pTemplate="caption">
                    <div class="reportMainFilter">
                        <div class="reportMainFields">
                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("searchLabel")}}</span>
                                <input pinputtext="" [(ngModel)]="Booking.name" autocomplete="off" [placeholder]='setLabel("searchHerePlaceholderLabel")'
                                    type="text" name="searchValue" (keyup)="searchLocal(Booking.name, 'name')"
                                    class="p-inputtext p-corner-all p-state-default p-widget" />
                            </div>
                            <div class="reportMainBtn">

                                <spanp [pTooltip]='setLabel("clearTooltipLabel")' class="iconClear" [disabled]="loading" (click)="resetFilter()"> <i
                                        class="pi pi-times"></i></spanp>
                            </div>
                        </div>
                        <div class="reportMainBtn">
                            <span [pTooltip]='setLabel("clearTooltipLabel")' class="iconClear hideOnLaptop" [disabled]="loading" (click)="resetFilter()"> <i
                                class="pi pi-times"></i></span>

                            <!-- <button style="background: #ffffff;color: #0e2031;margin-top: 10px;" (click)="resetFilter()"
                                class="p-button p-widget p-state-default p-corner-all p-button-text-only">Clear</button> -->
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{setLabel("membershipNumberLabel")}}</th>
                        <th>{{setLabel("memberLabel")}}</th>
                        <th>{{setLabel("slotNameLabel")}}</th>
                        <th>{{setLabel("statusLabel")}}</th>
                        <th>{{setLabel("startTimeLabel")}}</th>
                        <th>{{setLabel("endTimeLabel")}}</th>
                        <th>{{setLabel("createdDateLabel")}}</th>
                        <th>{{setLabel("commentLabel")}}</th>
                        <th>{{setLabel("actionLabel")}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-booking>
                    <tr class="p-selectable-row">
                        <td>
                            <span class="p-column-title">{{
                                booking.customer.tagNumber
                                }}</span>
                        </td>
                        <td>
                            <span class="p-column-title">{{
                                booking.customer.name
                                }}</span>
                        </td>
                        <td>
                            <span class="p-column-title">{{
                                booking.bookingSlot.name
                                }}</span>
                        </td>
                        <td>
                            <div
                                [ngClass]="{statusPending: booking.status=='Pending', statusApproved: booking.status=='Approved',
                            statusRejected: booking.status=='Rejected', statusWithDraw: booking.status=='WithDraw',  statusExpired: booking.status=='Expired'}">
                                <span class="p-column-title">{{
                                    booking.status
                                    }}</span>
                            </div>
                        </td>
                        <td>
                            <span style="
                                    vertical-align: middle;
                                    margin-left: 0.5em;
                                ">{{
                                booking.bookingSlot?.startTime | date: "shortTime"
                                }}</span>
                        </td>
                        <td>
                            <span style="
                                    vertical-align: middle;
                                    margin-left: 0.5em;
                                ">{{ booking.bookingSlot?.endTime | date: "shortTime" }}</span>
                        </td>
                        <td>
                            <span style="
                                    vertical-align: middle;
                                    margin-left: 0.5em;
                                ">{{ booking?.createdDate | date: "fullDate" }} {{ booking?.createdDate | date:
                                "shortTime" }}</span>
                        </td>
                        <td>
                            <span class="p-column-title">
                                {{booking.comment}}
                            </span>
                        </td>
                        <td>
                            <!-- <button pButton type="button" pTooltip="Details" icon="fa fa-pencil-square-o"
                                routerLink="booking/{{ booking._id }}"></button> -->
                            <!-- // -->
                            <button pButton type="button" [pTooltip]='setLabel("deleteBookingTooltipLabel")' class="p-button-danger p-button"
                                icon="fa fa-times" (click)="deleteBookingById(booking)"></button>&nbsp;
                            <button pButton type="button" [pTooltip]='setLabel("rejectRequestTooltipLabel")' *ngIf="booking.status === 'Pending'"
                                class="p-button-primary p-button" icon="fa fa-thermometer-empty"
                                style="background: #03A9F4" (click)="rejectRequest(booking)"></button>&nbsp;
                            <button pButton type="button" [pTooltip]='setLabel("approvedRequestTooltipLabel")'
                                *ngIf="booking.status === 'Pending'" class="p-button-primary p-button"
                                icon="fa fa-money" style="background: #1ab394"
                                (click)="approveRequest(booking)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6" style="text-align: left;">
                            {{setLabel("noBookingsFoundLabel")}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>